import { createSelector } from "reselect"
import { get, chain } from "lodash"

export const getWatchlists = state => get(state, "global.data.watchlists.data.watchlists")

export const getWatchlistsLookup = createSelector(
  [getWatchlists],
  (watchlists) => chain(watchlists)
    .keyBy("id")
    .mapValues(watchlist => ({
      name: watchlist.name,
      alias: watchlist.alias,
    }))
    .value(),
)
